export { default } from './GlobalAlert'
